if (typeof global === 'undefined') {
  window.global = window;
}